<template>
  <div
    v-if="canSee"
    ref="tabItem"
    class="header__menu-item flex items-center"
    @mouseover="hovered"
    @mouseleave="hovered(false)"
    @click="showChildren = !showChildren"
  >
    <!-- header -->
    <div
      class="flex items-center cursor-pointer header__menu-link px-2"
      :class="[
        {'header__menu-link--active': isHeaderActive},
        {'header-open': isHovered || showChildren},
        {'header__menu-link--has-icon': header.icon},
      ]"
      :data-text="header.header"
      @click="$router.push(header.items[0].url)"
    >
      <div v-if="header.icon" class="header__tab-icon mr-2">
        <dynamic-icon :icon="header.icon" />
      </div>
      <span
        :class="{'header__menu-text--active': isHeaderActive}"
        class="header__menu-text"
      >
        {{ header.header }}
      </span>
      <slot />
      <i-arrow-bottom class="ml-1" />
    </div>

    <!-- Children -->
    <transition name="fade-top-2x">
      <ul
        v-show="showChildren"
        ref="headerDropdown"
        class="header-children h-nav-menu-dd shadow-dropdown absolute py-3"
        :class="{'dd-right': dropRight}"
      >
        <li v-for="(item, index) in header.items" :key="item.name">
          <template v-if="!item.submenu">
            <h-nav-menu-item
              :to="item.slug !== 'external' ? item.url : ''"
              :href="item.slug === 'external' ? item.url : ''"
              :icon="item.icon"
              :target="item.target"
              :is-disabled="item.isDisabled"
              :slug="item.slug"
              :name="item.name"
              :is-submenu="true"
            >
              <span v-if="getTag(item.inc)" class="header-submenu__inc">{{ getTag(item.inc) }}</span>
            </h-nav-menu-item>
          </template>
          <template v-else>
            <h-nav-menu-group
              :key="`group-${index}`"
              open-hover
              :group="item"
              :group-index="index"
              :open="checkGrpChildrenActive(item)"
            />
          </template>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DynamicIcon from '@/components/DynamicIcon.vue';
import IArrowBottom from '@/assets/svg/icons/arrow-small-bottom.svg';
import { checkRole } from '@/constants';
import HNavMenuGroup from './HorizontalNavMenuGroup.vue';
import HNavMenuItem from './HorizontalNavMenuItem.vue';

export default {
  components: {
    HNavMenuGroup,
    HNavMenuItem,
    IArrowBottom,
    DynamicIcon,
  },
  props: {
    header: {
      type:     Object,
      requried: true,
    },
    openOnHover: {
      type:    Boolean,
      default: true,
    },
  },
  data() {
    return {
      showChildren: false,
      isHovered:    false,
      dropRight:    false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    canSee() {
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.header.items) {
        if (checkRole(this.$router.match(item.url).meta.rule, this.userInfo.userRole)) {
          return true;
        }
      }

      return false;
    },
    isHeaderActive() {
      const { path }    = this.$route;
      let active        = false;
      const routeParent = this.$route.meta ? this.$route.meta.parent : undefined;

      this.header.items.forEach((item) => {
        // If item is group
        if (item.submenu) {
          if (this.checkGrpChildrenActive(item)) { active = true; }
        } else if (item.url) {
          if (path === item.url || routeParent === item.slug) { active = true; }
        }
      });

      return active;
    },
  },
  watch: {
    showChildren() {
      this.$nextTick(() => {
        if (this.showChildren) {
          const dd = this.$refs.headerDropdown;
          if (dd.getBoundingClientRect().left + dd.offsetWidth - (window.innerWidth - 16) >= 0) {
            this.dropRight = true;
          }
        }
      });
    },
    isHeaderActive(val) {
      if (val) this.sendParentStyle(val);
    },
  },
  mounted() {
    this.sendParentStyle();
  },
  methods: {
    getTag(value) {
      return typeof value === 'string' ? this.$store.getters[value] : value;
    },
    checkGrpChildrenActive(group) {
      const { path }    = this.$route;
      let active        = false;
      const routeParent = this.$route.meta ? this.$route.meta.parent : undefined;

      if (group.submenu) {
        group.submenu.forEach((item) => {
          if ((path === item.url || routeParent === item.slug) && item.slug) {
            active = true;
          } else if (item.submenu) {
            // eslint-disable-next-line no-unused-expressions
            this.checkGrpChildrenActive(item) ? active = true : null;
          }
        });
      }

      return active;
    },
    hovered(val = true) {
      this.isHovered = val;
      if (this.openOnHover) {
        this.showChildren = !!val;
      }
    },

    sendParentStyle(isFormWatch = false) {
      if (!this.canSee) return;

      if (isFormWatch || this.isHeaderActive) {
        const { offsetWidth, offsetLeft } = this.$refs.tabItem;
        this.$emit('getActiveLinkStyle', { width: `${offsetWidth}px`, left: `${offsetLeft}px` });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenuHeader.scss";
</style>
